{
  "02a4fc7c14fd1f99": "Por favor proporcione al menos 30 caracteres",
  "09adde92f00886ef": "Registrar entrada",
  "0b69226a13ae20dd": "Este turno tiene una solicitud de Punch Perdido pendiente. Por favor, corrige y aprueba o rechaza la MPR antes de hacer ajustes en el turno.",
  "155f816c0407310c": "Enviar",
  "19766ed6ccb2f4a3": "Cancelar",
  "1d43329e847494c8": "Generar solicitud de entrada perdida sin firmar",
  "36da52013a723f9c": "No se pudo cargar el estado del turno",
  "4384a9db2738d8fd": "Se requiere solicitud de aclaración de fichaje",
  "45733af728fba90d": "Registrar salida",
  "54c7049be8221356": "Error al cargar los detalles del turno",
  "57cf1b694598e578": "Ver Solicitud de Punch Perdido",
  "5d78d3c01a7f3a10": "\"Solicitar pago por turno\" y seguir los pasos para recibir el pago por este turno.",
  "5e268c8f9361afbb": "Se aplica uno de los siguientes dos casos: El lugar de trabajo ha aprobado este aumento de tiempo de turno O el turno no es realmente",
  "638f63b642280192": "Este registro de entrada es antes de la hora de llegada del trabajador o la salida es después de la hora de partida. Enviar anulará el límite de geocerca.",
  "8016267a5d2d907d": "Error al enviar la solicitud de entrada perdida sin firmar",
  "8f227bc8dd1f19c3": "Hora de entrada",
  "a082fd30d7c96141": "Añada el motivo de la falta de registro de entrada/salida del trabajador",
  "a2578cd365b13e34": "Solicitud de entrada perdida sin firmar enviada con éxito",
  "a745945a992b3f06": "Para solicitar un cambio para este turno, ajuste al menos un campo de hora",
  "a8ab24521afb3b26": "Se aplica uno de los siguientes dos casos: El lugar de trabajo ha aprobado este ajuste de turno O el turno no está realmente",
  "c6f4af27d3c0ec8e": "elegible para MPR",
  "c9c8084eb6d3d632": "Por favor, ten en cuenta que este turno tiene una MPR aprobada. Te pedimos que revises los detalles cuidadosamente antes de proceder con cualquier ajuste.",
  "caed89bf40fc2c84": "No se permite procesar una hoja de tiempo en papel para este turno.",
  "dc5922e62a919fe5": "No se permite procesar una hoja de tiempo en papel para este turno. Por favor, pide al profesional que vaya a Historial de Turnos",
  "e005cecbc48072c2": "Hora de salida",
  "f3d8b1c69d1dd7ba": "No se pudieron cargar los detalles del turno del lugar de trabajo",
  "f81ab834de5f8491": "Razón",
  "fca73138f1f51921": "Motivo de la solicitud de entrada perdida"
}
